var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5c.28 0 .5.22.5.5v.86a.5.5 0 1 1-1 0V2c0-.28.22-.5.5-.5ZM12.6 3.4c.2.2.2.52 0 .71l-.61.6a.5.5 0 0 1-.7-.7l.6-.6c.2-.2.51-.2.7 0ZM12.64 8c0-.28.23-.5.5-.5H14a.5.5 0 1 1 0 1h-.86a.5.5 0 0 1-.5-.5ZM11.28 11.28c.2-.2.52-.2.71 0l.6.61a.5.5 0 0 1-.7.7l-.6-.6a.5.5 0 0 1 0-.7ZM3.4 3.4c.2-.2.52-.2.71 0l.6.61a.5.5 0 1 1-.7.7l-.6-.6a.5.5 0 0 1 0-.7ZM1.5 8c0-.28.22-.5.5-.5h.86a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5ZM4.72 11.28c.2.2.2.52 0 .71l-.6.6a.5.5 0 1 1-.72-.7l.61-.6c.2-.2.51-.2.7 0ZM6.29 10.47c.27 0 .5.22.5.5v1.31a1.21 1.21 0 0 0 2.42 0v-1.3a.5.5 0 0 1 1 0v1.3a2.21 2.21 0 1 1-4.42 0v-1.3c0-.29.22-.5.5-.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.07a2.93 2.93 0 1 0 0 5.86 2.93 2.93 0 0 0 0-5.86ZM4.07 8a3.93 3.93 0 1 1 7.86 0 3.93 3.93 0 0 1-7.86 0ZM8 13.5c.28 0 .5.22.5.5v.86a.5.5 0 1 1-1 0V14c0-.28.22-.5.5-.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.7f0b28d1504d539516afb90de26fd6a4.svg";
export { ForwardRef as ReactComponent };